export default __webpack_public_path__ + "static/media/membership-advantages.50179b3c.png";